<template>
  <div class="re_min_page re_sizing re_paddingtb_24 re_paddinglr_16 paddingb">
    <div class="noneImg" v-if="!infodata.photoUrl && loadingEnd">
      <img src="https://tp.kaishuihu.com/dsgc/icon/static/image/none.png" alt="">
      <p class="re_color_second">无法查看该内容或该内容已删除</p>
    </div>
    <template v-else-if="loadingEnd">
      <div class="top re_width100 re_flex re_flex_align">
        <img class="avatar" :src="infodata.photoUrl" alt="" />
        <div class="re_margin_l_8">
          <div class="title re_ellipsis re_font_14 re_font_bold">
            {{ infodata.userName }}
          </div>
          <span class="re_color_light re_font_12">{{ infodata.createTime }}</span>
        </div>
      </div>
      <div ref="content" v-if="showAll && infodata.content" class="content re_margin_top_16">
        <span v-if="infodata.isOriginal == 1" class="original">原创</span>
        {{ infodata.content }}
        <div v-if="infodata.content.length > 100" @click="showAllText(2)" class="re_color_active">
          收起
        </div>
      </div>
      <div ref="content" v-if="!showAll && infodata.content" class="content re_margin_top_16">
        <span v-if="infodata.isOriginal == 1" class="original">原创</span>
        {{ newStr }}
        <span @click="showAllText(1)" class="re_color_active">全文</span>
      </div>
      <div v-if="infodata.videoUrl" class="re_margin_top_16">
        <video controls :poster="infodata.videoPic" :src="infodata.videoUrl"></video>
      </div>
      <div class="re_relative" v-if="infodata.partyInfo">
        <img class="re_margin_top_16 partyInfo" :src="infodata.partyInfo.pic" alt="">
        <div class="picText re_absolute re_flex re_flex_align re_flex_justify re_sizing">
          <span class="re_font_14 re_color_white">{{ infodata.partyInfo.picText }}</span>
        </div>
      </div>
      <div v-else-if="infodata.pic.length > 1" class="fileBox re_margin_top_16">
        <template v-for="(item, index) in infodata.pic" :key="index">
          <img @click="showBig(index)" v-if="item != 'a'" :class="infodata.pic.length == 1 ? 'imgOne' : ''"
            :src="item.pic" alt="" />
          <div v-if="item == 'a'"></div>
        </template>
      </div>
      <div v-else-if="infodata.pic.length == 1" class="re_margin_top_16">
        <template v-for="(item, index) in infodata.pic" :key="index">
          <img @click="showBig(index)" v-if="item != 'a'" :class="infodata.pic.length == 1 ? 'imgOne' : ''"
            :src="item.pic" alt="" />
          <div v-if="item == 'a'"></div>
        </template>
      </div>
      
      <wx-open-launch-app v-if="isWeixin" id="launch-btn" appid="wxf1c9654e06a8af78" :extinfo="goAppStr"
        @launch="onLaunch" @error="onError">
        <component :is="'script'" v-bind="{ type: 'text/wxtag-template' }">
          <div style="display:flex;flex-direction: row;margin-top:16px;width:355px">
            <img style="height:24px" src="https://tp.kaishuihu.com/dsgc/icon/static/liuliuTip2.png" alt="">
          </div>
        </component>
      </wx-open-launch-app>

      <div class="comments" v-if="infodata.replyList.length">
        <div class="re_font_18 re_font_bold re_margin_bot_16">最新评论</div>
        <div v-for="(item, index) in infodata.replyList" :key="index" class="con">
          <template v-if="item.replyType == 1">
            <span class="nickName re_font_14 re_color_active">{{ item.replerName }}：</span>
            <span class="re_font_14">{{ item.reply }}</span>
          </template>
          <template v-else-if="item.replyType == 2">
            <span class="nickName re_font_14 re_color_active">{{ item.replerName }}</span>
            <span class="re_font_14 re_color_light">回复</span>
            <span class="nickName re_font_14 re_color_active">{{ item.ownerName }}：</span>
            <span class="re_font_14">{{ item.reply }}</span>
          </template>
        </div>
      </div>
    </template>

    <div>
      <div class="_xbanner"
        style="width: 100%;background: rgba(254,254,254,1);-webkit-box-shadow: 0px -2px 10px 0px rgba(13,13,13,0.1);box-shadow: 0px -2px 10px 0px rgba(13,13,13,0.1);position: fixed;left: 0;bottom: 0;">
        <table style="width: 100%;padding:0 10px;table-layout: fixed;" border="0" cellspacing="0" cellpadding="0">
          <tbody>
            <tr>
              <td style="width: 49px;height: 60px;display: table-cell;vertical-align: middle;text-align: center;"> <img
                  class="_xbanner_icon"
                  style="width: 42px;height: 42px;border-radius: 6px;margin-right: 6px;vertical-align: middle;"
                  src="https://img.xinstall.top/bannerIcon/vg9btw1/2026-08-15/pfby4y4neqgeg.png" alt=""> </td>
              <td style="height: 60px;vertical-align: middle;text-align: left">
                <p class="_xbanner_title"
                  style="line-height: 21px;color: rgba(51,51,51,1);font-size: 16px;font-weight: 500;margin: 0;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">
                  开水壶</p>
                <p class="_xbanner_desc"
                  style="line-height: 14px;color: rgba(153,153,153,1);font-size: 14px;margin: 3px 0 0 0;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">
                  陌生破冰，相识轻松！</p>
              </td>
              <td v-if="!isWeixin" @click="goAppStrFn" style="width: 105px;height: 60px;vertical-align: middle;text-align: right;"> <a
                  class="_xbanner_down_btn" href="javascript:;"
                  style="max-width:88px;background: rgba(24,144,255,1);border-radius: 17px;color:  rgba(255,255,255,1);cursor: pointer;display: inline-block;text-decoration: none;font-size: 14px;margin:0;padding: 7px 16px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                  打开APP </a> </td>
              <td v-if="isWeixin" style="width: 105px;height: 60px;vertical-align: middle;text-align: right;"> 
                <wx-open-launch-app id="launch-btn2" appid="wxf1c9654e06a8af78" :extinfo="goAppStr"
                  @launch="onLaunch" @error="onError">
                  <component :is="'script'" v-bind="{ type: 'text/wxtag-template' }">
                    <a class="_xbanner_down_btn" href="javascript:;"
                      style="max-width:88px;background: rgba(24,144,255,1);border-radius: 17px;color:  rgba(255,255,255,1);cursor: pointer;display: inline-block;text-decoration: none;font-size: 14px;margin:0;padding: 7px 16px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                      打开APP </a>
                  </component>
                </wx-open-launch-app>
              </td>
              
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>

import { info, shareConfig, shareMsg } from './api.js';
import { ref, onMounted } from 'vue';
import { showImagePreview } from 'vant';

const newStr = ref('');
const showAll = ref(false);
const loadingEnd = ref(false);
const contentStr = ref('');
const goAppStr = ref(JSON.stringify({
  android: 'com.hnpp.moments.MomentDetailActivity',
  id: sessionStorage.getItem('postId') || '',
  ios: 'MyPaiDetailViewController'
}))
const infodata = ref({});
const isWeixin = isWeChatBrowser()
function showBig(index) {
  let bigArr = []
  infodata.value.pic.forEach(item => {
    if (item.pic) {
      bigArr.push(item.pic)
    }
  })
  showImagePreview({
    images: bigArr,
    closeable: true,
    startPosition: index
  });
}

onMounted(() => {
  // wx-open-launch-app 仅在微信内可用，非微信环境无需 config
  if (isWeixin) getSign()
})

// 调起 App 成功
function onLaunch(e) {
  console.log('wx-open-launch-app launch:', e && e.detail)
}

// 调起失败（常见为 App 未安装 / appid 与移动应用不匹配），回落到下载页
function onError(e) {
  console.warn('wx-open-launch-app error:', e && e.detail)
  window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hnpp.llcb'
}

function getSign() {
  shareConfig().then(res => {
    if (res.code == 1) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        appId: res.data.appid, // 必填，公众号的唯一标识
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.signature,// 必填，签名
        jsApiList: [], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-app'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      });
      wx.ready(function () {
        // 开放标签在 config 成功后由微信自动接管点击
      })
      wx.error(function (err) {
        console.error('wx.config error:', err)
      })
    }
  })
}
function getShare() {
  shareMsg({
    accessType: 4
  }).then(res => {
    if (res.code == 1) {
      wx.onMenuShareAppMessage({
        title: res.data.title,
        desc: res.data.msg,
        link: res.data.link,
        imgUrl: res.data.icon,
        success: function (res) {
          /*shared(shareLink, "friend", shareGid);*/
          // alert("分享给朋友成功！");
        },
        fail: function (res) {
          // alert("分享给朋友失败！" + JSON.stringify(res));
        }
      });
      wx.onShareTimeline({
        title: res.data.title,
        desc: res.data.msg,
        link: res.data.link,
        imgUrl: res.data.icon,
        success: function (res) {
          /*shared(shareLink, "friend", shareGid);*/
          // alert("分享给朋友成功！");
        },
        fail: function (res) {
          // alert("分享给朋友失败！" + JSON.stringify(res));
        }
      });
    }
  })
}
function getStr() {
  if (infodata.value.pic.length == 2) {
    infodata.value.pic.push('a');
  } else if (infodata.value.pic.length == 4) {
    infodata.value.pic.splice(2, 0, 'a')
    infodata.value.pic.push('a');
  }
  if (infodata.value.content.length < 100) {
    showAll.value = true;
  } else {
    showAll.value = false;
  }
  newStr.value = infodata.value.content.substring(0, 100) + '...';
  console.log(showAll.value)
}
function showAllText(type) {
  if (type == 1) {
    showAll.value = true;
  } else {
    showAll.value = false;
  }
}
getInfo()
function getInfo() {
  info().then(res => {
    loadingEnd.value = true
    if (res.code == 1) {
      infodata.value = res.data
      getStr();
    }
  })
}

// APP配置
const AppConfig = {
  ios: {
    scheme: 'kaishuihu://', // iOS URL Scheme
    appstore: 'https://apps.apple.com/cn/app/%E5%BC%80%E6%B0%B4%E5%A3%B6-%E5%90%8C%E5%9F%8E%E5%85%B4%E8%B6%A3%E7%A4%BE%E4%BA%A4-%E7%BA%BF%E4%B8%8B%E6%B4%BB%E5%8A%A8%E7%BB%84%E5%B1%80%E5%B9%B3%E5%8F%B0/id1533388517', // App Store链接
  },
  android: {
    scheme: 'ksh://kaishuihu:8888/splash', // Android URL Scheme
    download: 'https://tp.kaishuihu.com/apk/ksh_314.apk' // 直接下载链接
  }
};

const timer = ref(null)

function goAppStrFn() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  // 是否微信
  if(isWeChatBrowser()) {
    window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hnpp.llcb'
  } else {
    console.log(isAndroid, isiOS)
    // /splash
    const device = isiOS ? 'ios' : 'android';
    const url = AppConfig[device].scheme;
    // 创建隐藏的iframe（传统方法）
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    document.body.appendChild(iframe);
    
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 100);
    
    // 尝试直接跳转（备用方法）
    window.location.href = url;
    _setupTimeoutDetection(device)
  }
}
// 构建APP URL
// function _buildAppUrl(device, path, params) {
//   const scheme = AppConfig[device].scheme;
//   const query = new URLSearchParams(params).toString();
//   return `${scheme}`;
// }
function _setupTimeoutDetection(device) {
  const visibilityChange = () => {
      if (document.hidden) {
        clearTimeout(timer.value);
      }
    };
    
  document.addEventListener('visibilitychange', visibilityChange);
  timer.value = setTimeout(() => {
    document.removeEventListener('visibilitychange', visibilityChange);

    if (device === 'ios') {
      window.location.href = AppConfig.ios.appstore;
    } else {
      const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = AppConfig.android.download;
        document.body.appendChild(iframe);
    }
  }, 2500);
}
function isWeChatBrowser() {
  // 获取浏览器的 userAgent 并转换为小写
  const userAgent = window.navigator.userAgent.toLowerCase();
  // 检测 userAgent 中是否包含 'micromessenger' 字符串
  if (userAgent.match(/micromessenger/i)) {
    return true;
  } else {
    return false;
  }
}
// setScript()
// function setScript() {
//   var script = document.createElement('script');
//   script.src = 'https://xinstall.top/xinstall/banner.js?xid=n7sqb528lm';
//   document.body.appendChild(script);
//   let a = document.getElementsByClassName('_xbanner_icon')
//   let b = document.getElementsByClassName('_xbanner_title')
//   let c = document.getElementsByClassName('_xbanner_desc')
//   console.log(a)
//   console.log(a.currentSrc, b.innerText, c.innerText)
// }
</script>
<style lang="less">
.paddingb {
  padding-bottom: 80px;
}
.liuliuTip {
  flex-direction: row-reverse;

  img {
    width: 210px;
    height: 24px;
  }
}
</style>
<style lang="less" scoped>
.top {
  box-sizing: border-box;

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 20px;
  }

  .title {
    max-width: 18.25rem;
  }
}

.fileBox {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-auto-rows: 100px;
  grid-gap: 5px;
}

.imgOne {
  width: 132px;
  // height: 200px;
  object-fit: cover;
  max-height: 200px;
  border-radius: 6px;
}

.content {
  white-space: pre-wrap;

  .original {
    color: #5381FF;
    font-size: 10px;
    line-height: 16px;
    width: 32px;
    text-align: center;
    border-radius: 4px;
    background: #5381ff1f;
    display: inline-block;
  }
}

.fileBox img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.comments {
  margin-top: 24px;
}

.con {
  line-height: 24px;
  margin-bottom: 12px;

  .nickName {
    // display: inline-block;
    // max-width:100px;
    // min-width: 50px;
    color: #505D80;
  }
}

.noneImg {
  padding-top: 120px;
  text-align: center;

  img {
    width: 130px;
  }
}

video {
  width: 200px;
  height: 300px;
}

.partyInfo {
  width: 288px;
  height: 147px;
  border-radius: 6px;
}

.picText {
  width: 288px;
  height: 32px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 0px 0px 6px 6px;
  left: 0;
  bottom: 5px;
  padding-left: 12px;
}
</style>